import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { fadeInOutAnimation } from '@app/core/animations';
import { SetCurrentApp } from '@app/core/states/app.actions';
import { OnboardingState } from '@app/core/states/onboarding.state';
import { ResponsiveState } from '@app/core/states/responsive.state';
import { SkipToStep } from '@app/core/states/stepper.actions';
import { UnsavedChangesService } from '@app/features/app-content/services/unsaved-changes.service';
import {
  FetchAppConfigRequest,
  FetchUserRadiosRequest,
} from '@app/features/app-content/states/app-configuration.actions';
import { AppConfigurationState } from '@app/features/app-content/states/app-configuration.state';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription, filter } from 'rxjs';

@Component({
  selector: 'rk-app-configuration-shell',
  templateUrl: './app-configuration-shell.component.html',
  styleUrls: ['./app-configuration-shell.component.scss'],
  animations: [fadeInOutAnimation],
  standalone: false,
})
export class AppConfigurationShellComponent implements OnInit, OnDestroy {
  @Select(AppConfigurationState.activeSettingsCategory)
  activeSettingsCategory$: Observable<string>;

  @Select(AppConfigurationState.currentAppWhmcsUserId)
  currentAppWhmcsUserId$: Observable<number>;

  @Select(AppConfigurationState.activePageType)
  activePageType$: Observable<string>;

  @Select(ResponsiveState.showAppConfigMobileWarning)
  showAppConfigMobileWarning$: Observable<boolean>;

  @Select(OnboardingState.modalName)
  onboardingModalName$: Observable<string>;

  @Select(OnboardingState.showModal)
  showOnboardingModal$: Observable<boolean>;

  constructor(
    private readonly store: Store,
    private readonly route: ActivatedRoute,
    private readonly unsavedChangesService: UnsavedChangesService,
  ) {}

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    if (this.unsavedChangesService.checkForUnsavedChanges()) {
      $event.returnValue = true;
    }
  }

  private readonly subscriptions: Subscription = new Subscription();

  ngOnInit() {
    this.store.dispatch(new SkipToStep(1));

    // fetch user radios
    this.subscriptions.add(
      this.currentAppWhmcsUserId$.pipe(filter(userId => !!userId)).subscribe(userId => {
        this.store.dispatch(new FetchUserRadiosRequest(userId));
      }),
    );

    // fetches app config
    this.subscriptions.add(
      this.route.params.subscribe(params => {
        const appId = params['appId'];
        if (appId) {
          this.store.dispatch(new FetchAppConfigRequest(appId));
          this.store.dispatch(new SetCurrentApp(Number(appId)));
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
